import React from 'react'
import { BarChart3, ChevronRight } from 'lucide-react'

/**
 * First card in a module's transactions grid — opens overview dashboard.
 * @param {string} prefix - CSS prefix e.g. "crm-activity", "sales-transaction"
 */
const ModuleOverviewCard = ({
  prefix,
  onClick,
  moduleName = 'Module',
  showArrow = true
}) => (
  <div
    className={`${prefix}-card clickable`}
    onClick={onClick}
    style={{ cursor: 'pointer' }}
    role="button"
    tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        onClick?.()
      }
    }}
  >
    <div className={`${prefix}-icon`}>
      <BarChart3 size={24} />
    </div>
    <div className={`${prefix}-content`}>
      <h3>Overview</h3>
      <p>View {moduleName} KPIs, metrics and activity summary</p>
      <div className={`${prefix}-count`}>Dashboard</div>
    </div>
    {showArrow && (
      <div className={`${prefix}-arrow`}>
        <ChevronRight size={16} />
      </div>
    )}
  </div>
)

export default ModuleOverviewCard
